// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"progress-bar_progressBar__mlQQT","background":"progress-bar_background__1VIUZ","active":"progress-bar_active__1lH3Q","text":"progress-bar_text__oqijf"};